module.exports = __webpack_public_path__ + "img/honor-qualification-bg.756628f.png";